var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructionsBlueHollow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77783 1H14.2222C14.6479 1 15 1.35236 15 1.77734V14.2227C15 14.6476 14.6479 15 14.2222 15H1.77783C1.35207 15 1 14.6476 1 14.2227V1.77734C1 1.35236 1.35207 1 1.77783 1Z",
    stroke: "#074B60",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44443 12.4436H8.88888C9.37776 12.4436 9.77776 12.0436 9.77776 11.5547C9.77776 11.0658 9.37776 10.6658 8.88888 10.6658H4.44443C3.95554 10.6658 3.55554 11.0658 3.55554 11.5547C3.55554 12.0436 3.95554 12.4436 4.44443 12.4436Z",
    fill: "#074B60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44443 8.88802H11.5555C12.0444 8.88802 12.4444 8.48802 12.4444 7.99913C12.4444 7.51024 12.0444 7.11024 11.5555 7.11024H4.44443C3.95554 7.11024 3.55554 7.51024 3.55554 7.99913C3.55554 8.48802 3.95554 8.88802 4.44443 8.88802Z",
    fill: "#074B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44443 5.33247H11.5555C12.0444 5.33247 12.4444 4.93247 12.4444 4.44358C12.4444 3.95469 12.0444 3.55469 11.5555 3.55469H4.44443C3.95554 3.55469 3.55554 3.95469 3.55554 4.44358C3.55554 4.93247 3.95554 5.33247 4.44443 5.33247Z",
    fill: "#074B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsBlueHollow);
export default __webpack_public_path__ + "static/media/instructions_blue_hollow.526fa5cfba70b2e727ff171eb60d7d7a.svg";
export { ForwardRef as ReactComponent };